import React from 'react';
import { Glyphicon } from 'react-bootstrap'

class Check extends React.Component
{
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

    render() {
        if (this.props.value)
            return <React.Fragment><Glyphicon glyph="ok"/></React.Fragment>

        return null
    }
}

export default Check;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/Check.js